import i18n from '@/i18n/i18n'
import { PreApprovedLimitApplicationService } from '@/services/admin/PreApprovedLimitApplicationService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['farmer_id', 'created_between', 'status', 'decision']
export const allowedIncludes = ['farmer:id,fullname,tckn,sex,address_id', 'decisions']
export const allowedSorts = '-created_at'

export const state = {
  preApprovedLimitApplications: [],
  preApprovedLimitApplication: null,
  meta: null,
  activities: [],
  findeksRequest: null,
  survey: []
}

export const mutations = {
  SET_PRE_APPROVED_LIMIT_APPLICATIONS(state, preApprovedLimitApplications) {
    state.preApprovedLimitApplications = preApprovedLimitApplications.data
    state.preApprovedLimitApplications.forEach(application => {
      application.decision = application.relationships?.decisions?.[0]?.decision
    })
    state.meta = preApprovedLimitApplications.meta
  },
  SET_PRE_APPROVED_LIMIT_APPLICATION(state, preApprovedLimitApplication) {
    state.preApprovedLimitApplication = preApprovedLimitApplication
  },
  SET_PRE_APPROVED_LIMIT_APPLICATION_ACTIVITIES(state, activities) {
    state.activities = activities
  },
  SET_PRE_APPROVED_LIMIT_APPLICATION_FINDEKS_REQUEST(state, findeksRequest) {
    state.findeksRequest = findeksRequest
  },
  SET_PRE_APPROVED_LIMIT_APPLICATION_SURVEY(state, survey) {
    state.survey = survey
  }
}

export const getters = {
  getExistingPreApprovedLimitApplication: state => id => {
    if (state.preApprovedLimitApplications.length > 0) {
      const app = state.preApprovedLimitApplications.find(
        preApprovedLimitApplication => preApprovedLimitApplication.id === id
      )

      return app
    }

    return null
  },
  getDecisionType: state => id => {
    if (state.preApprovedLimitApplications.length > 0) {
      const app = state.preApprovedLimitApplications.find(
        preApprovedLimitApplication => preApprovedLimitApplication.id === id
      )

      return app.relationships?.decisions?.[0]?.type
    }

    return null
  }
}

const preApprovedLimitApplicationService = new PreApprovedLimitApplicationService()

export const actions = {
  getPreApprovedLimitApplications({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

      preApprovedLimitApplicationService
        .getPreAprpovedLimitApplications(newQuery)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATIONS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('views.layouts.pre_approved_limit_applications')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPreApprovedLimitApplication({ commit, state, dispatch }, id) {
    if (state.preApprovedLimitApplications.length > 0) {
      const preApprovedLimitApplication = state.preApprovedLimitApplications.find(
        preApprovedLimitApplication => preApprovedLimitApplication.id === id
      )

      if (preApprovedLimitApplication !== null) {
        commit('SET_PRE_APPROVED_LIMIT_APPLICATION', preApprovedLimitApplication)
        return preApprovedLimitApplication
      }
    }

    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .getPreAprpovedLimitApplication(id)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('views.layouts.pre_approved_limit_application')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPreApprovedLimitApplicationFindeksRequest({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .getPreApprovedLimitApplicationFindeksRequest(id)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION_FINDEKS_REQUEST', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('views.layouts.pre_approved_limit_application_findeks_request')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPreApprovedLimitApplicationActivities({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .getPreAprpovedLimitApplicationActivities(id)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION_ACTIVITIES', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('views.admin.pre_approved_limit_applications.pre_approved_limit_application_activities')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPreApprovedLimitApplicationAnswers({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .getPreApprovedLimitApplicationAnswers(id)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION_SURVEY', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('views.admin.pre_approved_limit_applications.answers')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  saveKycCksDecision({ commit, dispatch, state }, decision) {
    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .saveKycCksDecision(state.preApprovedLimitApplication.id, decision)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION', response.data)

          const message = decision
            ? t('views.admin.pre_approved_limit_applications.kyc_cks_approve_success')
            : t('views.admin.pre_approved_limit_applications.kyc_cks_reject_success')

          const notification = {
            type: 'success',
            message: message
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const message = decision
            ? t('views.admin.pre_approved_limit_applications.kyc_cks_approve_failed')
            : t('views.admin.pre_approved_limit_applications.kyc_cks_reject_failed')

          const notification = {
            type: 'danger',
            message: `${message} ${errorMessage(err)}`
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  approveKycDocument({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      preApprovedLimitApplicationService
        .approveKycDocument(state.preApprovedLimitApplication.id)
        .then(response => {
          commit('SET_PRE_APPROVED_LIMIT_APPLICATION', response.data)

          const notification = {
            type: 'success',
            message: t('views.admin.pre_approved_limit_applications.kyc_approve_document_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('views.admin.pre_approved_limit_applications.kyc_approve_document_failed') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportPreApprovedLimitApplications({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)

    return new Promise(reject => {
      preApprovedLimitApplicationService
        .exportPreApprovedLimitApplications(newQuery)
        .then(() => {
          const notification = {
            type: 'info',
            message: t(
              'store.shared.exporting' +
                {
                  element: t('views.layouts.pre_approved_limit_applications')
                }
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.exporting_error', {
                element: t('views.layouts.pre_approved_limit_applications')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
